// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__1qo2-","summary":"CartItem_summary__1VIoN","price":"CartItem_price__2F18X","amount":"CartItem_amount__XuCC8","actions":"CartItem_actions__f1lFJ"};